import { ChevronDown } from '@sortlist-frontend/design-system/icons';

import type { GuidePageContent } from '../types';

interface GuideFaqProps {
  section: GuidePageContent['faq'];
}

export const GuideFaq = (props: GuideFaqProps) => {
  const { section } = props;

  return (
    <section id="faq" className="scroll-mt-24" aria-labelledby="faq-title">
      <h2 id="faq-title" className="text-2xl font-semibold text-secondary-950">
        {section.title}
      </h2>
      <div className="mt-4 divide-y divide-secondary-200 rounded-2xl border border-secondary-200 bg-white px-5">
        {section.items.map((item) => (
          <details key={item.question} className="group py-5">
            <summary className="flex cursor-pointer list-none items-center justify-between gap-4 [&::-webkit-details-marker]:hidden">
              <h3 className="font-semibold text-secondary-950">{item.question}</h3>
              <ChevronDown
                size={18}
                className="shrink-0 transition-transform group-open:rotate-180"
                aria-hidden="true"
              />
            </summary>
            <p className="mt-3 leading-relaxed text-secondary-700">{item.answer}</p>
          </details>
        ))}
      </div>
    </section>
  );
};
